import React, { Component } from "react";
import {connect} from "react-redux";
import {
  deleteCacheForEventStats,
  fetchCongressesDetails,
  getCacheOldestEntryPeriodForEventStats,
  getEventStatsDataTable,
  getGlobalEventStats,
} from "../../../../actions/thunks/eventStats";
import EventCharts from "../EventCharts";
import EventCardFeetching from "../../../feetching/EventCardFeetching";
import FacturationStatsCard from "./FacturationStatsCard";
import _ from 'i18n';
import {setEventDataTableAppTypeFilter} from "../../../../actions/actions/eventStats";
import {InfoCircleOutlined} from "@ant-design/icons";
import {Tooltip} from "antd";
import {Icon} from "antd";
import {showErrorNotification} from "../../../../services/utils";
import SaisonFilter from "../../../Filters/EventStats/SaisonFilter";

@connect(store => ({
  auth: store.auth
}))
 class FacturationStats extends Component {

   constructor(props) {
     super(props);

     this.state = {
       appType: 'global',
       color: '#29394D',
       refreshing: false,
       cacheOldestEntryPeriod: 0,
       fetchingCacheOldestEntryPeriod: true,
       globalStatsError: false,
     };
   }

   handleAppTypeSelect = (appType, color) => {
     this.setState({
       appType: appType,
       color
     });

     if(appType == 'registering' || appType == 'cycle_registering' || appType == 'all_in' || appType == 'congres' || appType == 'cycle_essential')
       this.props.setEventDataTableAppTypeFilter([appType]);

   };

   componentDidMount() {
     this.getEventStats();
     this.props.getCacheOldestEntryPeriodForEventStats().then(res => {
       this.setState({cacheOldestEntryPeriod: res.data.data.cacheOldestEntryPeriod, fetchingCacheOldestEntryPeriod: false});
     });
   }

   componentDidUpdate(nextProps, nextState, nextContext) {
     const{eventStatsFilter} = this.props;

     if (nextProps.eventStatsFilter.year !== eventStatsFilter.year || nextProps.eventStatsFilter.startMonth !== eventStatsFilter.startMonth || nextProps.eventStatsFilter.endMonth !== eventStatsFilter.endMonth || nextProps.eventStatsFilter.season !== eventStatsFilter.season) {
       this.getEventStats();
     }
   }

   getEventStats = () => {
     this.setState({globalStatsError: false})
     let params = {};

     if (this.props.eventStatsFilter.year.length > 0) {
       params.year = this.props.eventStatsFilter.year;
     }

     if(this.props.auth.currentClient) {
       params.issuerId = this.props.auth.currentClient.id;
     }
     // was used
     params.startMonth = this.props.eventStatsFilter.startMonth;
     params.endMonth = this.props.eventStatsFilter.endMonth;


     params.season = isNaN(this.props.eventStatsFilter.season) ? this.props.eventStatsFilter.season : Number(this.props.eventStatsFilter.season);

     this.props.getGlobalEventStats(params).then((res) => {}).catch((err) => {
       /*if(err.message.includes("504") || err.message.includes("Network Error")){
         this.setState({globalStatsError: true})
       }*/
       if(err.message != "Operation canceled by the user."){
         this.setState({globalStatsError: true})
       }
     });
   }

   refreshData = () => {
     this.setState({refreshing :true});

     this.props.deleteCacheForEventStats().then((res) => {
       this.setState({refreshing: false, cacheOldestEntryPeriod: 0});
       this.getEventStats();
       this.getEventStatsDataTable();
       }
     ).catch((err) => {
         this.setState({refreshing: false});
         showErrorNotification(_('error'), _('errorOccured'));
       }
     );

   }

   getEventStatsDataTable = () => {
     const {eventStatsFilter} = this.props;

     let params = {};

     if (this.props.eventStatsFilter.search.trim() !== "") {
       params.search = this.props.eventStatsFilter.search;
     }

     if (this.props.eventStatsFilter.year.length > 0) {
       params.year = this.props.eventStatsFilter.year;
     }

     if (this.props.eventStatsFilter.appType.length > 0) {
       params.appType = this.props.eventStatsFilter.appType;
     }

     if(this.props.auth.currentClient) {
       params.issuerId = this.props.auth.currentClient.id;
     }

     params.limit = this.props.eventStatsFilter.pageSize;
     params.start = (this.props.eventStatsFilter.current - 1) * this.props.eventStatsFilter.pageSize;
     params.lang = this.props.eventStatsFilter.language;
     params.startMonth = this.props.eventStatsFilter.startMonth;
     params.endMonth = this.props.eventStatsFilter.endMonth;
     params.season = isNaN(this.props.eventStatsFilter.season) ? this.props.eventStatsFilter.season : Number(this.props.eventStatsFilter.season);
     params.activitiesOrder = this.props.eventStatsFilter.activitiesOrder;

     if(eventStatsFilter.appType != 'congres'){
       this.props.getEventStatsDataTable(params);
     } else {
       this.props.fetchCongressesDetails(params);
     }
   }

    secondsToHm = (d) => {
     if(d < 60)
       return _('NOW');

     d = Number(d);
     var h = Math.floor(d / 3600);
     var m = Math.floor(d % 3600 / 60);

     var hDisplay = h > 0 ? h + "h" : "";
     var mDisplay = m >= 10 ? m + "min" : "0" + m + "min";

     return hDisplay + mDisplay;
   }

  render() {
    const { auth } = this.props;
    const { appType, color, refreshing, cacheOldestEntryPeriod, fetchingCacheOldestEntryPeriod, globalStatsError } = this.state;
    const {fetching, fetched} = this.props.eventStatsGlobal;
    const { all_in, cycle, formation, premium, congrès, cycle_essential}= this.props.eventStatsGlobal.items;
    const {lng} = this.props;
    let cacheOldestEntryPeriodFormatted = this.secondsToHm(cacheOldestEntryPeriod);

    //Global card statistics are calculated in the front =( (to-modify)
    // we  get the userIds to calculate the number of persons for the global card
    //Sometimes we get an object of user ids instead of an array, to be sure we do this conversion
    if(formation && formation.hasNotPaidUserIds){
      formation.hasNotPaidUserIds = Object.values(formation.hasNotPaidUserIds);
      formation.hasPaidUserIds = Object.values(formation.hasPaidUserIds);
      cycle.hasNotPaidUserIds = Object.values(cycle.hasNotPaidUserIds);
      cycle.hasPaidUserIds = Object.values(cycle.hasPaidUserIds);
      all_in.hasNotPaidUserIds = Object.values(all_in.hasNotPaidUserIds);
      all_in.hasPaidUserIds = Object.values(all_in.hasPaidUserIds);
      premium.hasNotPaidUserIds = Object.values(premium.hasNotPaidUserIds);
      premium.hasPaidUserIds = Object.values(premium.hasPaidUserIds);
      congrès.hasNotPaidUserIds = Object.values(congrès.hasNotPaidUserIds);
      congrès.hasPaidUserIds = Object.values(congrès.hasPaidUserIds);
      cycle_essential.hasNotPaidUserIds = Object.values(cycle_essential.hasNotPaidUserIds);
      cycle_essential.hasPaidUserIds = Object.values(cycle_essential.hasPaidUserIds);
    }

    return (
      <div>
        <div className={'flex items-center'} style={{marginBottom: '18px', justifyContent: 'space-between'}}>
          <div className={'flex items-center'}>
            <div className={'event-stats-section-title mr-2'} style={{marginBottom: '0'}}>{_('FACTURATIONS')}</div>
            <Icon type="reload" spin={refreshing} style={{fontSize: '20px', color: '#29394D'}} onClick={() => this.refreshData()}/>
            {
              fetchingCacheOldestEntryPeriod == false &&
              <div className={'data-info ml-2'}
                  style={{marginBottom: '0'}}>{_('LAST_CACHE_UPDATE') + (cacheOldestEntryPeriod < 60 ? cacheOldestEntryPeriodFormatted : (lng == 'fr' ? 'il y a ' + cacheOldestEntryPeriodFormatted : (lng == 'eng' ? cacheOldestEntryPeriodFormatted + ' ago' : cacheOldestEntryPeriodFormatted + ' geleden')))}</div>
            }
          </div>
          <SaisonFilter />
        </div>
        {
          globalStatsError === false ?
            <div className={'flex justify-between'} style={{justifyContent: auth.currentClient.id == 9 ? '' : 'space-evenly'}}>
              <div style={{width: '15%', marginRight : "3px"}}>
                {
                  fetching ? <EventCardFeetching appType={'global'}/> :
                    <FacturationStatsCard selected={appType === 'global'}
                                          appType={'global'}
                                          formation={formation && formation}
                                          cycle={cycle && cycle}
                                          all_in={all_in && all_in}
                                          premium={premium && premium}
                                          congrès={congrès && congrès}
                                          cycle_essential= {cycle_essential && cycle_essential}
                                          color="#29394D"
                                          handleAppTypeSelect={this.handleAppTypeSelect}

                    />
                }
              </div>
              <div style={{width: '15%', marginRight : "3px"}}>
                {
                  fetching ? <EventCardFeetching appType={'registering'}/> :
                    <FacturationStatsCard selected={appType === 'registering'}
                                          appType={'registering'}
                                          nbrActivities={formation && formation.nbrActivities}
                                          paidRegistrant={formation && formation.paidRegistrant}
                                          notpaidRegistrant={formation && formation.hasNotPaidUserIds.length}
                                          inDistinctPaidRegistrant={formation && formation.inDistinctPaidRegistrant}
                                          inDistinctNotPaidRegistrant={formation && formation.notPaidRegistrant}
                                          hasPaidUserIds={formation && formation.hasPaidUserIds}
                                          hasNotPaidUserIds={formation && formation.hasNotPaidUserIds}
                                          color="#18A0FB"
                                          handleAppTypeSelect={this.handleAppTypeSelect}
                    />
                }
              </div>
              {
                (auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') ? (
                  <div style={{width: '15%', marginRight : "3px"}}>
                    {
                      fetching ? <EventCardFeetching appType={'cycle_registering'}/> :
                        <FacturationStatsCard selected={appType === 'cycle_registering'}
                                              appType={'cycle_registering'}
                                              nbrActivities={cycle && cycle.nbrActivities}
                                              paidRegistrant={cycle && cycle.paidRegistrant}
                                              notpaidRegistrant={cycle && cycle.hasNotPaidUserIds.length}
                                              inDistinctPaidRegistrant={cycle && cycle.inDistinctPaidRegistrant}
                                              inDistinctNotPaidRegistrant={cycle && cycle.notPaidRegistrant}
                                              hasPaidUserIds={cycle && cycle.hasPaidUserIds}
                                              hasNotPaidUserIds={cycle && cycle.hasNotPaidUserIds}
                                              color="#5F5DE8"
                                              handleAppTypeSelect={this.handleAppTypeSelect}
                        />
                    }
                  </div>
                ) : null
              }
              {
                auth.currentClient.businessType === 'SUPER_CHAIN' ? (
                  <React.Fragment>
                    <div style={{width: '15%', marginRight : "3px"}}>
                    {
                      fetching ? <EventCardFeetching appType={'all_in'}/> :
                        <FacturationStatsCard selected={appType === 'all_in'}
                                              appType={'all_in'}
                                              nbrActivities={all_in && all_in.nbrActivities}
                                              paidRegistrant={all_in && all_in.paidRegistrant}
                                              notpaidRegistrant={all_in && all_in.hasNotPaidUserIds.length}
                                              inDistinctPaidRegistrant={all_in && all_in.inDistinctPaidRegistrant}
                                              inDistinctNotPaidRegistrant={all_in && all_in.notPaidRegistrant}
                                              hasPaidUserIds={all_in && all_in.hasPaidUserIds}
                                              hasNotPaidUserIds={all_in && all_in.hasNotPaidUserIds}
                                              color="#F47F4D"
                                              handleAppTypeSelect={this.handleAppTypeSelect}
                        />
                    }
                    </div>
                    <div style={{width: '15%', marginRight : "3px"}}>
                    {
                      fetching ? <EventCardFeetching appType={'premium'}/> :
                        <FacturationStatsCard selected={appType === 'premium'}
                                              appType={'premium'}
                                              nbrActivities={premium && premium.nbrActivities}
                                              paidRegistrant={premium && premium.paidRegistrant}
                                              notpaidRegistrant={premium && premium.hasNotPaidUserIds.length}
                                              inDistinctPaidRegistrant={premium && premium.inDistinctPaidRegistrant}
                                              inDistinctNotPaidRegistrant={premium && premium.notPaidRegistrant}
                                              hasPaidUserIds={premium && premium.hasPaidUserIds}
                                              hasNotPaidUserIds={premium && premium.hasNotPaidUserIds}
                                              color="#FB1E5B"
                                              handleAppTypeSelect={this.handleAppTypeSelect}
                        />
                    }
                    </div>
                    <div style={{width: '15%', marginRight : "3px"}}>
                    {
                      fetching ? <EventCardFeetching appType={'cycle_essential'}/> :
                        <FacturationStatsCard selected={appType === 'cycle_essential'}
                                              appType={'cycle_essential'}
                                              nbrActivities={cycle_essential && cycle_essential.nbrActivities}
                                              paidRegistrant={cycle_essential && cycle_essential.paidRegistrant}
                                              notpaidRegistrant={cycle_essential && cycle_essential.hasNotPaidUserIds.length}
                                              inDistinctPaidRegistrant={cycle_essential && cycle_essential.inDistinctPaidRegistrant}
                                              inDistinctNotPaidRegistrant={cycle_essential && cycle_essential.notPaidRegistrant}
                                              hasPaidUserIds={cycle_essential && cycle_essential.hasPaidUserIds}
                                              hasNotPaidUserIds={cycle_essential && cycle_essential.hasNotPaidUserIds}
                                              color="#14B7AD"
                                              handleAppTypeSelect={this.handleAppTypeSelect}
                        />
                    }
                    </div>
                    <div style={{width: '15%'}}>
                    {
                      fetching ? <EventCardFeetching appType={'congrès'}/> :
                        <FacturationStatsCard selected={appType === 'congres'}
                                              appType={'congres'}
                                              nbrActivities={congrès && congrès.nbrActivities}
                                              paidRegistrant={congrès && congrès.paidRegistrant}
                                              notpaidRegistrant={congrès && congrès.hasNotPaidUserIds.length}
                                              inDistinctPaidRegistrant={congrès && congrès.inDistinctPaidRegistrant}
                                              inDistinctNotPaidRegistrant={congrès && congrès.notPaidRegistrant}
                                              hasPaidUserIds={congrès && congrès.hasPaidUserIds}
                                              hasNotPaidUserIds={congrès && congrès.hasNotPaidUserIds}
                                              color="#6D7F92"
                                              handleAppTypeSelect={this.handleAppTypeSelect}
                        />
                    }
                    </div>
                  </React.Fragment>
                ) : null
              }
            </div>
            :
            <div className={'flex items-center flex-column justify-center retry-container'} style={{minHeight : '200px'}}>
              <div className={'retry-label mb-3'}>{_('ERROR_OCCURED')}</div>
              <button type={"button"} className={'retry-button'} onClick={this.getEventStats}>
                {_('RETRY')}
              </button>
            </div>
        }

        {
          fetched &&
          <div className={'facturation-charts-container event'} style={{borderColor: color}}>
            <EventCharts event={appType == 'global' ? this.props.eventStatsGlobal.items :
              (appType == 'registering' ? formation :
                  (appType == 'cycle_registering' ? cycle :
                      (appType == 'all_in' ? all_in :
                        (appType == 'premium' ? premium :
                          (appType == "cycle_essential" ? cycle_essential : congrès))
                  )
              ))}/>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventStatsGlobal: state.eventStatsGlobal,
  auth: state.auth,
  lng: state.params.lng,
});

const mapDispatchToProps = {
  getGlobalEventStats,
  setEventDataTableAppTypeFilter,
  deleteCacheForEventStats,
  getEventStatsDataTable,
  fetchCongressesDetails,
  getCacheOldestEntryPeriodForEventStats,
};

export default connect(mapStateToProps, mapDispatchToProps)(FacturationStats);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/Facturation/FacturationStats.js